import React, { useState } from "react";
import Draggable from "react-draggable";
import { Image, Toast } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import AnimatedCol from "../../../../../../components/AnimatedCol";
import DickeWeicheBodenschicht from "../../general/DickeWeicheBodenschicht";
import DickeWeicheBodenschichtImage from "../../../../../../images/Knicken/20231010_Ofner Wimmer Knickfigur.png";
import KoeffizientNachGudehus from "./KoeffizientNachGudehus";
import KoeffizientNachWenz from "./KoeffizientNachWenz";
import TeilsicherheitsbeiwertBodenkenngroessen from "./TeilsicherheitsbeiwertBodenkenngroessen";
import UndraenierteScherfestigkeit from "./UndraenierteScherfestigkeit";
import HiddenWrapperRow from "../../../../../../components/UI/HiddenWrapperRow";

function ParameterBaugrund({ expand, Nj, kc, ky }) {
  const { t } = useTranslation("translation");
  const hide = `${expand ? "box" : "d-sm-none"} `;
  const [showDickeWeicheBodenschichtImage, setDickeWeicheBodenschichtImage] = useState(false);
  return (
    <div>
      <div className="row">
        <div className={`${hide} col-md-12`}>
          <h1>{t("inner.buckling.ofner.parameterSoil.headline")}</h1>
        </div>
      </div>
      <div className="row">
        <AnimatedCol>
          <DickeWeicheBodenschicht
            showImage={setDickeWeicheBodenschichtImage}
            show={showDickeWeicheBodenschichtImage}
          />
        </AnimatedCol>
        <HiddenWrapperRow>
          <ShowImageDetails
            show={showDickeWeicheBodenschichtImage}
            setShow={setDickeWeicheBodenschichtImage}
            image={DickeWeicheBodenschichtImage}
          />
        </HiddenWrapperRow>
        <AnimatedCol>
          <UndraenierteScherfestigkeit />
        </AnimatedCol>

        <AnimatedCol expand={expand}>
          <TeilsicherheitsbeiwertBodenkenngroessen teilsicherheitsbeiwertBodenkenngroessen={Nj} />
        </AnimatedCol>

        <AnimatedCol expand={expand}>
          <KoeffizientNachWenz koeffizientNachWenz={kc} />
        </AnimatedCol>

        <AnimatedCol expand={expand}>
          <KoeffizientNachGudehus koeffizientNachGudehus={ky} />
        </AnimatedCol>
      </div>
    </div>
  );
}

function ShowImageDetails({ show, setShow, image }) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable nodeRef={nodeRef}>
      <Toast
        ref={nodeRef}
        onClose={() => setShow(!show)}
        show={show}
        animation={false}
        style={{
          zIndex: 1000,
          backgroundColor: "white",
          position: "absolute",
          width: "auto",
          height: "auto",
        }}
      >
        <Toast.Header className="d-flex flex-row-reverse"></Toast.Header>
        <Toast.Body>
          <Image width={"300px"} src={image} alt="" />
        </Toast.Body>
      </Toast>
    </Draggable>
  );
}
export default ParameterBaugrund;
